import Title from 'components/Title';
import { toast } from 'react-toastify';
import { getDevErrorData, getDevOkData } from '../../helpers/backend-helper';
import { useEffect } from 'react';

/**
 * このページは開発用のテストをするページで本番では運用しません。
 */
const DevPage = () => {
  const fetchDevOkData = async () => {
    try {
      // ここに開発用のAPIを呼び出す処理を書く
      const res = await getDevOkData();
      console.log('res', res);
    } catch (e) {
      console.error('fetchDevOkDataエラーが発生しました', e);
    }
  };

  const fetchDevErrorData = async () => {
    try {
      // ここに開発用のAPIを呼び出す処理を書く
      const res = await getDevErrorData();
      console.log('res', res);
    } catch (e) {
      console.error('fetchDevErrorDataエラーが発生しました', e);
      toast('fetchDevErrorDataエラーが発生しました');
    }
  };

  useEffect(() => {
    (async () => {
      await fetchDevOkData();
      await fetchDevErrorData();
    })();
  }, []);
  return (
    <div>
      <Title title={'開発テストページ'} textAlign={'center'} />
    </div>
  );
};

export default DevPage;
